import { useEffect, useState } from "react";

const DebugButton = () => {
    const [debugVisible, setDebugVisible] = useState(false);

    useEffect(() => {
        if (window.Telegram?.WebApp) {
            console.log("✅ Telegram WebApp API доступен");
        } else {
            console.log("⚠️ Telegram WebApp API не найден");
        }
    }, []);

    const showDebugInfo = () => {
        console.log("🔍 WebApp initData:", window.Telegram?.WebApp?.initData);
        console.log("🔍 WebApp initDataUnsafe:", window.Telegram?.WebApp?.initDataUnsafe);
        console.log(`Debug Info:\n${JSON.stringify(window.Telegram?.WebApp?.initDataUnsafe, null, 2)}`);
    };

    const openInBrowser = () => {
        const url = window.Telegram?.WebApp?.initDataUnsafe?.start_param
            ? `https://t.me/${window.Telegram.WebApp.initDataUnsafe.start_param}`
            : window.location.href;

        window.open(url, "_blank");
    };

    return (
        <div>
            {/* Кнопка в углу */}
            <button
                onClick={() => setDebugVisible(!debugVisible)}
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "#ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "none",
                    cursor: "pointer",
                }}
            >
                ⚙️
            </button>

            {/* Панель отладки */}
            {debugVisible && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "70px",
                        right: "20px",
                        background: "white",
                        padding: "10px",
                        borderRadius: "10px",
                        boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                    }}
                >
                    <button onClick={showDebugInfo} style={{ marginBottom: "5px" }}>
                        Показать Debug Info
                    </button>
                    <button onClick={openInBrowser}>
                        Включить Debug Mode
                    </button>
                </div>
            )}
        </div>
    );
};

export default DebugButton;